// Backup an existing real directory before replacing it with a symlink.
//
// Use case: avatar sync --force needs to override .claude/skills/ (which user
// may have manually populated) with a symlink to .claude/pack/skills/. We must
// NOT silently delete user content — instead rename to a timestamped backup so
// they can restore.
//
// Backup naming: <dir>.backup-YYYY-MM-DD-HHMM
import { promises as fs } from "node:fs";

// Build timestamp suffix in local time. Format: YYYY-MM-DD-HHMM
function timestamp(): string {
  const d = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `-${pad(d.getHours())}${pad(d.getMinutes())}`
  );
}

// Rename targetPath to "<targetPath>.backup-<timestamp>". Returns backup path.
// Caller is responsible for any subsequent symlink/dir creation at targetPath.
export async function backupDirBeforeReplace(targetPath: string): Promise<string> {
  const backupPath = `${targetPath}.backup-${timestamp()}`;
  await fs.rename(targetPath, backupPath);
  return backupPath;
}
